Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};
     
    Vendd.inlineEdit.helpers = Vendd.inlineEdit.helpers || {};

});